module.exports = __webpack_public_path__ + "img/cta-bg.1ab19ebb.png";